import AreaDirectorSortableErPlusJobsList from "../react/AreaDirectorSortableErPlusJobsList";
import AutoSaveTextField from "../components/AutoSaveTextField";
import JobCard from "@components/jobs/job_card_component/job_card_component";

export default class ErPlusJobs {
  constructor(params) {
    this.params = params;
  }

  index() {
    const keys = ["my", "cross"];
    const klass = AreaDirectorSortableErPlusJobsList;
    return this.sortAds(keys, klass);
  }

  show() {
    new JobCard(".job-card");

    if ($("#er_plus_job_alternate_website_url")) {
      this.initAutoSaveTextFields();
      $("#er_plus_job_alternate_website_url").on("keypress", (event) => {
        // listening for "enter" key press, we don't want to submit the form
        if (event.key === "Enter") {
          event.preventDefault();
          $(event.target).trigger("blur");
        }
      });
    }
  }

  sortAds(keys, klass) {
    keys.forEach((ele) => {
      if ($(`.js-erplus-react-data-${ele}`).length) {
        const list = new klass({
          sortScope: `#sort-filters-${ele}`,
          selector: `.js-erplus-list-${ele}`,
          data: $(`.js-erplus-react-data-${ele}`).data("jobs"),
          roleType: this.role,
        });
        list.render();
      }
    });
  }

  alternateWebsiteTextFieldUrl() {
    return `/er_plus_jobs/${this.params.id}/alternate_website_url`;
  }

  initAutoSaveTextFields() {
    new AutoSaveTextField(this, {
      attrName: "alternate_website_url",
      klass: "er_plus_job",
      submitUrl: this.alternateWebsiteTextFieldUrl(),
    });
  }

  runCallbacks() {}
}
